import { atom } from 'jotai';
import { atomFamily, atomWithReset } from 'jotai/utils';

import type { ChatbotPrimeData, ChatDialog } from 'src/types/chatbot';

import { ChatbotState } from './constants';

export const chatbotVisibilityState = atom(ChatbotState.VISIBLE);

export const chatbotChatAtomFamily = atomFamily(() => atom<ChatDialog>([]));

export const chatbotPrimeData = atomFamily(() =>
  atomWithReset<ChatbotPrimeData>({}),
);

export const chatbotPrimeTexts = atomFamily((key: string) =>
  atom(
    (get) => get(chatbotPrimeData(key)),
    (get, set, newValue: ChatbotPrimeData) => {
      const currentChatbotData = get(chatbotPrimeData(key));
      const newChatbotData = {};
      Object.entries(newValue).map(([key, value]) =>
        Object.assign(newChatbotData, {
          ...(currentChatbotData[key]
            ? { [key]: { ...currentChatbotData[key], ...value } }
            : { [key]: value }),
        }),
      );
      set(chatbotPrimeData(key), { ...currentChatbotData, ...newChatbotData });
    },
  ),
);
